
window.addEventListener("load", function () {
  const supportedLangs = ['en', 'vn', 'th', 'id', 'cn'];
  const lang = supportedLangs.find((l) => document.body.classList.contains(l)) || 'en';
  const btnTest = document.querySelector('#ovensmash-26-pre-testPer .btn_test');
  const popupGame = document.querySelector('#popup_game');
  const popupInform = document.querySelector('#popup_inform_test');
  const popupResult = document.querySelector('#popup_result');
  const popupConfirm = document.querySelector('#popup_confirm');
  const resultImgEl = document.querySelector('#popup_game_result .img_result img');
  const informText = document.querySelector('#popup_inform_test .text__inform');
  const informMessages = {
    en: 'You need to complete registration before taking the test.',
    vn: 'Bạn cần hoàn thành đăng ký trước khi làm bài test',
    th: 'คุณต้องทำการลงทะเบียนล่วงหน้าให้สำเร็จก่อนจึงจะทำแบบทดสอบได้',
    id: 'Kamu harus menyelesaikan pre-registrasi sebelum mengikuti tes.',
    cn: '请先完成注册后再进行测试。'
  };
 const RESULT_STORAGE_KEY = `ovensmash_pretest_result_v1_${lang}`;

  function showPopup(el) {
    if (!el) return;
    el.classList.add('active');
  }

  function hidePopup(el) {
    if (!el) return;
    el.classList.remove('active');
  }

  function scrollPopupToTop(popupEl) {
    if (!popupEl) return;
    const content = popupEl.querySelector('.MS__content');
    if (content) {
      try {
        content.scrollTo({ top: 0, behavior: 'smooth' });
      } catch (_) {
        content.scrollTop = 0;
      }
    }
  }

  function readSavedResult() {
    try {
      const raw = localStorage.getItem(RESULT_STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (_) {
      return null;
    }
  }

  if (btnTest) {
    btnTest.addEventListener('click', function (e) {
      e.preventDefault();

      const loginValue = Number(window.isLogin_);
      if (loginValue === 1) {
        hidePopup(popupInform);
        hidePopup(popupConfirm);

        const saved = readSavedResult();
        if (saved && saved.imgSrc) {
          if (resultImgEl) resultImgEl.src = saved.imgSrc;
          hidePopup(popupGame);
          showPopup(popupResult);
          scrollPopupToTop(popupResult);
          return;
        }

        hidePopup(popupResult);
        showPopup(popupGame);
        return;
      }

      if (informText) {
        informText.innerHTML = informMessages[lang] || informMessages.en;
      }
      showPopup(popupInform);
    });
  }

});
